import { useContext } from 'react'

import FieldContext from './FieldContext'

const useFieldContext = (): {
  prefix?: string
} => useContext(FieldContext)

export default useFieldContext
